import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {QuestionFlowSessionQuery} from '../../questions/state/question-flow-session.query';
import {Question} from '../../models/underwriter.model';
import {AuthenticationService} from '../../../authentication/service/authentication.service';
import {UserStore} from '../../../authentication/state/user.store';
import {newGuid} from '../../questions/question-helper';
import {API_PATH, RouterLinks} from '../../constants';
import {GlobalQuestionService} from '../../services/global-question.service';
import {Router} from '@angular/router';

declare const $: any;
declare const Dropzone: any;
declare const dropzonePreviewTemplate: any;

@Component({
    selector: 'app-question-add-note-modal',
    templateUrl: './question-add-note-modal.component.html',
    styleUrls: ['./question-add-note-modal.component.scss'],
    standalone: false
})
export class QuestionAddNoteModalComponent implements OnInit {

  session_details: any;
  question: Question;
  note = '';
  dropZone: any;
  acceptedFileTypes = 'image/*';
  fileSelectorEl = `question-note-uploader-${newGuid()}`;
  savedResources: any[] = [];
  buttonDisabled = true;
  @Output() noteChanged = new EventEmitter<Question>();

  constructor(
    private questionSession: QuestionFlowSessionQuery,
    private authService: AuthenticationService,
    private userStore: UserStore,
    private questionService: GlobalQuestionService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.session_details = this.questionSession.getValue();
  }

  showModal(question: Question): void {
    this.note = '';
    this.savedResources = [];
    this.buttonDisabled = true;
    this.question = question;
    if (this.question?.comment) {
      this.note = this.question?.comment;
      this.buttonDisabled = false;
    }
    /*if (this.dropZone) {
      this.dropZone?.destroy();
    }
    this.refreshToken();*/
    $('#question-add-note__modal').modal('show');
  }

  refreshToken(): void {
    this.authService.refreshToken()
      .subscribe(x => {
        this.userStore.update({
          access_token: x?.access_token,
          refresh_token: x?.refresh_token
        });
        this.initDropzone(x?.access_token);
      });
  }

  onChange(): void {
    this.buttonDisabled = !this.note;
  }

  initDropzone(token: string): void {
    this.dropZone = new Dropzone(`#${this.fileSelectorEl}`, {
      autoProcessQueue: true, // if false, call this.dropZone.processQueue()
      autoDiscover: false,
      acceptedFiles: this.acceptedFileTypes,
      previewTemplate: dropzonePreviewTemplate,
      thumbnailWidth: 204,
      thumbnailHeight: 204,
      maxFilesize: 200,
      url: API_PATH.UPLOAD_RESOURCE,
      headers: {
        Authorization: `Bearer ${token}`
      },
    }).on('thumbnail', (file: any) => {
      $(file.previewElement).addClass('has-thumbnail');
    }).on('success', (file: any, response: any) => {
      if (!this.savedResources || this.savedResources?.length) {
        this.savedResources = [];
      }
      this.savedResources.push({resource_id: response, file: file?.upload?.uuid});
    }).on('removedfile', (file: any) => {
      const deletedFile = this.savedResources.find((item: any) => item.file === file?.upload?.uuid);
      if (deletedFile) {
        this.savedResources = this.savedResources.filter(item => item.file !== file?.upload?.uuid);
        this.removeFile(deletedFile.resource_id);
      }
    }).on('error', (file: any, response: any) => {
      if (response?.indexOf('401') !== -1) {
        this.router.navigate([RouterLinks.Login], {queryParams: {returnUrl: this.router.routerState.snapshot.url}});
      }
    });

    if (this.question?.comment_files) {
      const response = JSON.parse(this.question?.comment_files);

      response.forEach((res: any) => {
        const resource_id = res.resource_id;
        const mockFile = {
          name: resource_id,
          size: 12345
        };
        this.dropZone.emit('addedfile', mockFile);
        this.dropZone.emit('thumbnail', mockFile, `${API_PATH.UPLOAD_RESOURCE}/${resource_id}`);
        this.dropZone.emit('success', mockFile, resource_id);
      });

    }
  }

  removeFile(resource_id: string): void {
    this.questionService.removeFile(resource_id);
  }

  deleteNote(): void {
    this.question.comment = '';
    /*this.question.note_files = '';*/
    this.noteChanged.emit(this.question);
    $('#question-add-note__modal').modal('hide');
  }

  save(): void {
    this.question.comment = this.note;
    /*this.question.note_files = JSON.stringify(this.savedResources);
    if (!this.savedResources || this.savedResources?.length) {
      this.question.note_files = '';
    }*/
    if (this.question?.comment) {
      this.noteChanged.emit(this.question);
      $('#question-add-note__modal').modal('hide');
    }
  }

}
